import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import VideoPlayer from './components/video/video2';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay/*, Pagination*/, Navigation } from "swiper";
import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/index.css';
import './css/header.css';

class Index extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			clubbers: {},
			radio: {},
			hyper: [],
			evolution: [],
			next: {},
			posters: {},
			sets: {},
			event: {},
			schedule: '',

			IndexSchedule: null,
			affliiate: {},
			channel: [null, -1],
		};
		this.startVideo = this.startVideo.bind(this);
		this.endVideo = this.endVideo.bind(this);
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});


		let params = new URLSearchParams();
		const x = await postApi('/api/v2/index2', params);
		//console.log(x.data);

		let schedule = Math.random()<0.5?'hyper':'evolution';
		if( Object.keys(x.data.hyper).length === 0 && Object.keys(x.data.evolution).length > 0 ) schedule = 'evolution';
		if( Object.keys(x.data.evolution).length === 0 && Object.keys(x.data.hyper).length > 0 ) schedule = 'hyper';

		this.setState({hyper: x.data.hyper, evolution: x.data.evolution, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, schedule, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});


	}

	componentWillUnmount() {
	}

	startVideo(channel) {
		for( let i in this.state[channel] ) {
			if( this.state[channel][i]?.isLive === true ) {
				this.setState({channel: [channel, i]});
			}
		}
	}

	endVideo() {
		this.setState({channel: [null, -1]});
	}
	

	render() {
		const user = this.context;
		const nextHyper = Object.keys(this.state.hyper).slice(0,2).map((e,i) => {
			return (
				<Col xs={12} key={i}>
					<Row className="gx-0 box-nownext-top">
						<Col xs={2} className="p-1">
							<img src={`https://mix365.co.uk${this.state.hyper[e].avatar}`} width="100%" />
						</Col>
						<Col className="text-vcenter">
							{this.state.hyper[e].isLive === true &&
								<span className="nowlive">LIVE</span>
							}
							<div>
								<div className="home-next-swiper-content-dj2">
									{this.state.hyper[e].djtitle?this.state.hyper[e].djtitle:this.state.hyper[e].username}<br />
								</div>
								<div className="home-next-swiper-content-time2">
									{moment(this.state.hyper[e].start*1000).format("HH:mm")} - {moment(this.state.hyper[e].end*1000).format("HH:mm")}
								</div>
							</div>
						</Col>
					</Row>
				</Col>
			)
		});
		const nextEvolution = Object.keys(this.state.evolution).slice(0,2).map((e,i) => {
			return (
				<Col xs={12} key={i}>
					<Row className="gx-0 box-nownext-top">
						<Col xs={2} className="p-1">
							<img src={`https://mix365.co.uk${this.state.evolution[e].avatar}`} width="100%" />
						</Col>
						<Col className="text-vcenter">
							{/*<span className="nowlive">LIVE</span>*/}
							<div>
								<div className="home-next-swiper-content-dj2">
									{this.state.evolution[e].djtitle?this.state.evolution[e].djtitle:this.state.evolution[e].username}<br />
								</div>
								<div className="home-next-swiper-content-time2">
									{moment(this.state.evolution[e].start*1000).format("HH:mm")} - {moment(this.state.evolution[e].end*1000).format("HH:mm")}
								</div>
							</div>
						</Col>
					</Row>
				</Col>
			)
		});
		const posters = Object.keys(this.state.posters).map((e,i) => {
			return (
				<SwiperSlide key={i} className="weeklydjs-card">
					<div className="weeklydjs-avatar">
						<Link to={`/${this.state.posters[e].username.replaceAll(' ','_')}`}><img src={`https://mix365.co.uk/${this.state.posters[e].avatar}`} alt="DJ Profile Avatar" className="weeklydjs-avatar-img" /></Link>
					</div>
					<Row className="home-nl-bottom gx-0">
						{/*<div style={{width: 80}}><img src={`https://mix365.co.uk${this.state.radio.avatar}`} className="home-stream-profile" alt="DJ Profile Avatar" /></div>*/}
						<Col xs={12}>
							{this.state.posters[e].title?this.state.posters[e].title:this.state.posters[e].username}<br />
							
							
						</Col>
						<Col xs={12}>
							{Object.keys(this.state.posters[e].sets).map((f,j) => {
								return (
									<React.Fragment key={j}>{moment(this.state.posters[e].sets[f]*1000).format("dddd - HH:mm")}<br /></React.Fragment>
								)
							})}
						</Col>
						<Col xs={12}>
							<ul className="weeklydjs-socials">
								{this.state.posters[e].facebook &&
									<li>
										<a href={this.state.posters[e].facebook} title="Facebook" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
										</a>
									</li>
								}
								{/*<li>H</li>*/}
								{this.state.posters[e].instagram &&
									<li>
										<a href={this.state.posters[e].instagram} title="Instagram" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
										</a>
									</li>
								}
								{this.state.posters[e].mixcloud &&
									<li>
										<a href={this.state.posters[e].mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
										</a>
									</li>
								}
								{this.state.posters[e].soundcloud &&
									<li>
										<a href={this.state.posters[e].soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
										</a>
									</li>
								}
								{this.state.posters[e].twitch &&
									<li>
										<a href={this.state.posters[e].twitch} title="Twitch" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
										</a>
									</li>
								}
								{this.state.posters[e].youtube &&
									<li>
										<a href={this.state.posters[e].youtube} title="Youtube" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
										</a>
									</li>
								}
							</ul>
						</Col>
					</Row>
				</SwiperSlide>
			)
		})
		const previous = Object.keys(this.state.sets).map((e,i) => {
			return (
				<Col md={4} key={i}>
					<AudioBox audio={this.state.sets[e]} />
				</Col>
			)
		})
		return (
			<>
				{this.state.status &&
					<>
						<div className="home-intro">
							<div className="home-intro-background"></div>
							<div className="home-inner"></div>
						</div>
						{/*<div className="website-background"></div>*/}
						<div className="article">
							<div className="home">
							
								<div className="home-live2 text-vcenter">
									<div className="text-vertical">
										<div>
											<div className="home-header-white text-center">WELCOME TO</div>
											<div className="home-body">MIX365 RADIO</div>
										</div>
										
									</div>
								</div>










									
								<Row className="gx-0">
									<Col xs={{ span: 10, offset: 1 }} md={{ span: 4, offset: 1 }} className="box-nownext" style={{}}>
										<Link to={'/hyper'} onMouseEnter={()=>this.startVideo('hyper')} style={{color: '#ffffff'}}>
											<img src='/images/channel_hyper0.png' width="100%" />
											<Row className="">
												{nextHyper}
											</Row>
										</Link>
										{this.state.channel[0] === 'hyper' &&
											<div className="play-live" onMouseLeave={()=>this.endVideo()}>
												<div className="box-nownext play-backing">
												<Link to={'/hyper'} style={{color: '#ffffff'}}>
													<VideoPlayer
														id="video"
														url={this.state.channel[0]} //{this.state.select.address}
														//select={this.state.select_temp.select}
														uid={this.state.clubbers?.uid}
														mini={true}
														//theatre={this.theatre}
														//onError={this.onError}
														//height={this.state.meta.video.height}
													/>
													<Col xs={12}>
														
															<Row className="gx-0 box-nownext-top">
																<Col xs={2} className="p-1">
																	<img src={`https://mix365.co.uk${this.state[this.state.channel[0]][this.state.channel[1]].avatar}`} width="100%" />
																</Col>
																<Col className="text-vcenter">
																	<span className="nowlive">LIVE</span>
																	<div>
																		<div className="home-next-swiper-content-dj2">
																			{this.state[this.state.channel[0]][this.state.channel[1]].djtitle?this.state[this.state.channel[0]][this.state.channel[1]].djtitle:this.state[this.state.channel[0]][this.state.channel[1]].username}<br />
																		</div>
																		<div className="home-next-swiper-content-time2">
																			{moment(this.state[this.state.channel[0]][this.state.channel[1]].start*1000).format("HH:mm")} - {moment(this.state[this.state.channel[0]][this.state.channel[1]].end*1000).format("HH:mm")}
																		</div>
																	</div>
																</Col>
															</Row>
														
													</Col>
													</Link>
												</div>
											</div>
										}
									</Col>
									<Col xs={{ span: 10, offset: 1 }} md={{ span: 4, offset: 2 }} className="box-nownext" style={{}}>
										<Link to={'/evolution'} onMouseEnter={()=>this.startVideo('evolution')} style={{color: '#ffffff'}}>
											<img src='/images/channel_evolution0.png' width="100%" />
											<Row className="">
												{nextEvolution}
											</Row>
										</Link>
										{this.state.channel[0] === 'evolution' &&
											<div className="play-live" onMouseLeave={()=>this.endVideo()}>
												<div className="box-nownext play-backing">
													<Link to={'/evolution'} style={{color: '#ffffff'}}>
														<VideoPlayer
															id="video"
															url={this.state.channel[0]} //{this.state.select.address}
															//select={this.state.select_temp.select}
															uid={this.state.clubbers?.uid}
															mini={true}
															//theatre={this.theatre}
															//onError={this.onError}
															//height={this.state.meta.video.height}
														/>
														<Col xs={12}>
														
															<Row className="gx-0 box-nownext-top">
																<Col xs={2} className="p-1">
																	<img src={`https://mix365.co.uk${this.state[this.state.channel[0]][this.state.channel[1]].avatar}`} width="100%" />
																</Col>
																<Col className="text-vcenter">
																	<span className="nowlive">LIVE</span>
																	<div>
																		<div className="home-next-swiper-content-dj2">
																			{this.state[this.state.channel[0]][this.state.channel[1]].djtitle?this.state[this.state.channel[0]][this.state.channel[1]].djtitle:this.state[this.state.channel[0]][this.state.channel[1]].username}<br />
																		</div>
																		<div className="home-next-swiper-content-time2">
																			{moment(this.state[this.state.channel[0]][this.state.channel[1]].start*1000).format("HH:mm")} - {moment(this.state[this.state.channel[0]][this.state.channel[1]].end*1000).format("HH:mm")}
																		</div>
																	</div>
																</Col>
															</Row>
														</Col>
													</Link>
												</div>
											</div>
										}
									</Col>
								</Row>
								
								
							</div>
						</div>

						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
							
							</h2>
						</div>

						<Row className="justify-content-center text-center my-5">

						  <Col xs={12} md={10}>

						    <img

						      src="/images/eventslogo.png"

						      alt="Intro Banner"

						      className="img-fluid mb-4"

						      style={{ maxWidth: '80%', height: 'auto' }}

						    />

						    <img
						      src="/images/upcomingevents.png"
						      alt="Upcoming Events"
						      className="img-fluid"
						      style={{ maxWidth: '100%', borderRadius: '8px' }}
						    />
						  </Col>
						</Row>



						<div className="home-aboutus">
							
								<Row className="article-entry gx-0 my-5">
									<Col md={6}>
										<img src="/images/home_about.jpg" alt="About Mix365" />
									</Col>
									<Col className="text-vertical ">
										<div className="home-aboutus-text">
											<h1>
												<span> </span>
												Welcome to the one and only mix365 "lean back, hit play, and let the good times roll!"
											</h1>
											<span className="home-aboutus-span">it’s not just a playlist, it’s a vibe!</span><br /><br />
											<p>
												Mix365 is a pioneering radio station devoted exclusively to electronic music, offering an electrifying blend of live DJ streams and on-demand audio content that resonates with fans around the globe. Dedicated to showcasing the vibrant world of electronic sound, Mix365 features a rich array of genres including techno, house, trance, ambient, and experimental beats, ensuring that every listener finds a rhythm that speaks to them.

At the heart of Mix365 lies its commitment to live DJ performances. These dynamic broadcasts capture the energy and spontaneity of artists who craft their sets in real time, delivering a performance that is both immersive and interactive. Listeners can enjoy the thrill of live mixes that seamlessly blend tracks, engage with the DJs during live chat sessions, and experience the creative process as it unfolds. This connection between performer and audience makes each live session a unique celebration of musical artistry.
											</p>
											
											<Link to='/about'><Button size="sm">Read more</Button></Link>
										</div>
									</Col>
									<Col xs={12}></Col>

									<Col className="text-vertical">
										<div className="home-aboutus-text text-right">
											<h1>
												<span>Schedule</span>
												Mix365 {this.state.schedule.charAt(0).toUpperCase() + this.state.schedule.slice(1)}
											</h1>
											<span className="home-aboutus-span">Bringing you more than just great music</span><br /><br />
											<p>Listening to Mix365 is simple and convenient wherever you are. You can stream directly from our website by clicking the “Live” link on our website, offering an easy way to dive into our live DJ sessions and on-demand mixes on any device. If you enjoy engaging with our community through our live broadcasts on the website, join us also on Twitch to catch real-time shows and interact with DJs during their sets. For a hands-free experience, just ask your Alexa-enabled device to play Mix365, and you’re set to enjoy uninterrupted electronic music. And if you’re on the move, our mobile app—available on Google Play—ensures that the vibrant world of Mix365 is always at your fingertips.</p>
											<Link to={`/${this.state.schedule}/schedule`}><Button size="sm">View Schedule</Button></Link>
										</div>
										
									</Col>

									<Col md={6}>
										<img src={`https://mix365.co.uk/images/live/${this.state.schedule}-schedule.png?d=${Date.now()}`} alt="About Mix365" />
									</Col>

									<Col md={6}>
										{Object.keys(this.state.hyper).length > 0 ?
											<img src={`https://mix365.co.uk/images/live/${this.state.hyper[0].uid}.png?d=${Date.now()}`} alt="About Mix365" />
										:
											<>
												{Object.keys(this.state.evolution).length > 0 ?
													<img src={`https://mix365.co.uk/images/live/${this.state.evolution[0].uid}.png?d=${Date.now()}`} alt="About Mix365" />
												:
													<img src={`https://mix365.co.uk/images/live/61.png?d=${Date.now()}`} alt="About Mix365" />
												}
											</>
										}
									</Col>
									<Col className="text-vertical ">
										<div className="home-aboutus-text">
											<h1>
												<span>Interact</span>
												Live Stream
											</h1>
											<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
											<p>
												Step into the soundscape of Mix365, where our two dynamic channels deliver an unstoppable flow of electronic beats — 24/7. From hard-thumping techno and euphoric trance to driving house, deep ambient textures, and high-octane drum and bass, we’ve got something to ignite every kind of electronic music lover. Whether you're craving a deep journey into progressive sounds or the adrenaline rush of fast-paced breaks, you’ll find your perfect vibe right here.

Explore both of our curated channels and hear what makes Mix365 truly unique. While you're listening, why not join the conversation? Our chat rooms are always open — all you need to do is log in. Say hi, share your thoughts, and support the DJs as they go live with real-time sets crafted just for you. At Mix365, you're not just tuning in — you're joining a global community that lives and breathes electronic music.
											</p>
											<Link to='/hyper'><Button size="sm">Live Stream</Button></Link>
										</div>
									</Col>
								</Row>
							
						</div>
						{Object.keys(this.state.event).length > 0 &&
							<>
								<div className="splitter text-center">
									<div className="splitter-cover"></div>
									<h2 className="splitter-text">
										Event XYZ
									</h2>
								</div>
								<div className="home-aboutus">
									<div className="article">
										<Row className="article-entry">
											<Col>
												<h3>Event XYZ</h3><br />
												Some description of the next upcoming event<br /><br />
												<Link to='/about'><Button size="sm">Read more</Button></Link>
											</Col>
											<Col md={4}>
												<img src="/images/home-bg01.jpg" alt="About Mix365" />
											</Col>
										</Row>
									</div>
								</div>
							</>
						}
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Meet the Mix365 DJ's
							</h2>
						</div>
						<div className="home-aboutus">
							<Row className="article-entry">
								<Col className="text-vertical">
									<div className="home-aboutus-text">
										<h1>
											<span>REGULAR DJ'S</span>
											Meet our Mix365 Weekly DJ's
										</h1>
										<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
										<p>

At Mix365, our DJs aren’t just background voices — they’re the heartbeat of the station. Each artist brings their own style, passion, and musical journey to the decks. By exploring their DJ profiles, you can get to know the people behind the music — learn about their influences, discover what genres they love to spin, and see when they’re next going live. Missed a session? No problem. Every show is recorded and available for playback, so you can catch up on the mixes that made waves, or revisit your favorites anytime. Whether you're a dedicated fan or new to the scene, browsing the DJ lineup and diving into past sets is the perfect way to connect with the personalities shaping the Mix365 sound.
</p>


										<Link to='/mix365djs'><Button size="sm">View All DJ'a</Button></Link>
									</div>
								</Col>
							</Row>
							<div className="article">
								<Row className="article-entry">
									<Col className="weeklydjs">
										<Swiper
											spaceBetween={50}
											breakpoints={{576: {slidesPerView: 1,},768: {slidesPerView: 2,},992: {slidesPerView: 3,},1200: {slidesPerView: 4,},1400: {slidesPerView: 5,}}}
											navigation={{
												prevEl: '.swiper2-prev',
												nextEl: '.swiper2-next',
											}}
											pagination={{clickable: true}}
											modules={[Autoplay, Navigation]}
											autoplay={{delay: 5000, disableOnInteraction: false,}}
										>
											{posters}
										</Swiper>
										<div className="swiper2-prev"><FontAwesomeIcon icon="circle-left" size="2x" /></div>
    								<div className="swiper2-next"><FontAwesomeIcon icon="circle-right" size="2x" /></div>
									</Col>
								</Row>
							</div>
						</div>
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Replay A Show
							</h2>
						</div>
						<div className="home-aboutus">
							
							<Row className="article-entry">
								<Col className="text-vertical">
									<div className="home-aboutus-text">
										<h1>
											<span>REPLAY SHOW</span>
											PREVIOUS SETS
										</h1>
										<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
										<p>

Here at <strong>Mix365</strong>, we totally get that life can be busy — work, family, late nights, early mornings — it doesn’t always line up with catching your favorite DJ live. That’s why we do everything we can to make sure you never miss a beat. Did you know that every one of our DJ’s shows is recorded and available for you to enjoy again, anytime you want? Whether you missed a live set, want to relive an epic mix, or just need something fresh to power your day, we’ve got you covered. Just head over to our <strong>Previous Shows</strong> page, search for your favorite DJ or show, and hit play. It’s that easy. So no stress — listen on your schedule, not ours!

</p>
										<Link to='/previous-sets'><Button size="sm">Previous Sets</Button></Link>
									</div>
								</Col>
							</Row>
							<div className="article">
								<Row className="article-entry h-100">
									{previous}
								</Row>
							</div>
						</div>
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Follow Us
							</h2>
						</div>
						<div className="home-aboutus">
							<div className="article text-center">
								<ul className="home-followus">
									<li>
										<a href="https://www.facebook.com/groups/mix365" title="Facebook" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" /> Facebook
										</a>
									</li>
									<li>
										<a href="https://www.instagram.com/mix365radio/" title="Instagram" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" /> Instagram
										</a>
									</li>
									<li>
										<a href="https://twitter.com/Mix365R" title="Twitter" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'twitter']} className="header-socials" /> Twitter
										</a>
									</li>
									<li>
										<a href="https://discord.gg/DtRYeVPJ5J" title="Discord" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'discord']} className="header-socials" /> Discord
										</a>
									</li>
								</ul>
							</div>
						</div>
						{Object.values(this.state.affliiate).length > 0 &&
							<div className="affiliates">
								<div className="text-center">
									<a href={this.state.affliiate.url} alt="affiliates" target="_blank" rel="noreferrer">
										<img src={`https://mix365.co.uk${this.state.affliiate.image}`} />
									</a>
								</div>
							</div>
						}
					</>
				}
			</>
		);
	}
}

export default Index;
